module.exports = __webpack_public_path__ + "static/media/vantr-illustration.197a98e8.webp";